var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    attrs: {
      rules: _vm.addRegexToValidationRules,
      tag: "div",
      vid: _vm.$attrs.id,
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  {
                    "error-styles": errors[0] || _vm.maxNumberCharactersExceed,
                  },
                  { "hidden-field": _vm.hidden },
                  { "disabled-field": _vm.$attrs.disabled },
                  "lf-textarea-container",
                ],
              },
              [
                _c(
                  "span",
                  {
                    class: [
                      { "required-field": _vm.requiredField },
                      "label-text",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.$attrs.label))]
                ),
                _c("div", { staticClass: "lf-textarea-input" }, [
                  _c(
                    "textarea",
                    _vm._b(
                      {
                        class: [
                          {
                            "error-styles":
                              errors[0] || _vm.maxNumberCharactersExceed,
                          },
                          "lf-textarea",
                        ],
                        attrs: { maxlength: _vm.$attrs.maxlength + 1 },
                        domProps: { value: _vm.innerValue },
                        on: { input: _vm.emitValue },
                      },
                      "textarea",
                      _vm.$attrs,
                      false
                    )
                  ),
                  _vm.value && _vm.value.length
                    ? _c("span", {
                        class: [_vm.icons.clearIcon, "clean-icon"],
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.cleanText.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
                _c("div", { staticClass: "messages-container" }, [
                  _c("div", { staticClass: "messages" }, [
                    errors.length
                      ? _c("span", { staticClass: "alert-message" }, [
                          _vm._v(_vm._s(errors[0])),
                        ])
                      : _c("span", { staticClass: "help-message" }, [
                          _vm._v(_vm._s(_vm.helpText)),
                        ]),
                  ]),
                  _vm.$attrs.maxlength
                    ? _c(
                        "div",
                        {
                          class: [
                            { "limit-reached": _vm.maxNumberCharactersExceed },
                            "counter",
                          ],
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.value ? _vm.value.length : "0") +
                              " / " +
                              _vm._s(_vm.$attrs.maxlength)
                          ),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }